<template>
  <div>
    <div>新增商户</div>
    <div class="form_container">
      <form class="form">
        <div class="form_row">
          <div class="label">公司名称</div>
          <input class="input" placeholder="公司名称" v-model="name">
        </div>
        <div class="form_row">
          <div class="label">公司地址</div>
          <input class="input" placeholder="公司地址" v-model="address">
        </div>
        <div class="form_row">
          <div class="label">公司电话</div>
          <input class="input" placeholder="公司电话" v-model="phone">
        </div>
        <div class="form_row">
          <div class="label">公司简介</div>
          <input class="input" placeholder="公司简介" v-model="description" />
        </div>
        <div class="form_row">
          <div class="label">法人</div>
          <input class="input" placeholder="法人" v-model="legalRepresentative" />
        </div>
        <div class="form_row">
          <div class="label">联系人</div>
          <input class="input" placeholder="联系人" v-model="contact" />
        </div>
        <div class="form_row">
          <div class="label">联系人电话</div>
          <input class="input" placeholder="联系人电话" v-model="contactPhone" />
        </div>
        <div class="form_row">
          <div class="label">邮箱</div>
          <input class="input" placeholder="邮箱" v-model="email" />
        </div>
        <div class="form_row">
          <div class="label">纳税人识别号</div>
          <input class="input" placeholder="纳税人识别号" v-model="taxpayerNumber" />
        </div>
        <div class="form_row">
          <div class="label">开户行名称</div>
          <input class="input" placeholder="开户行名称" v-model="bankName" />
        </div>
        <div class="form_row">
          <div class="label">银行账户</div>
          <input class="input" placeholder="银行账户" v-model="bankAccount" />
        </div>
        <div class="form_row">
          <div class="label">分润类型</div>
          <input class="input" placeholder="分润类型" disabled v-model="feeType" />
        </div>
        <div class="form_row">
          <div class="label">分润比 %</div>
          <input class="input" placeholder="分润比" v-model="amount" />
        </div>
        <div class="form_row" v-if="partnerId === 'M202306050008'">
          <div class="label">token</div>
          <input class="input" placeholder="token" v-model="token" />
        </div>

        <div class="button_container">
          <a href="javascript:" role="button" class="weui-btn weui-btn_primary" @click="submitPartnerApply">确认</a>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {addPartner, modChehaoliangToken, modPartner} from "../api";
import {getPartnerFee} from "../graphql/api";

export default {
  name: "add_partner",
  data() {
    return {
      name: '',
      address: '',
      phone: '',
      description: '',
      legalRepresentative: '',
      contact: '',
      contactPhone: '',
      email: '',
      taxpayerNumber: '',
      bankName: '',
      bankAccount: '',
      startTime: '',
      endTime: '',
      feeType: '按比例',
      amount: '',
      token: null,
      partnerId: '',

      canModAmount: false,
    }
  },
  mounted() {
    if (this.$route.params.partner) {
      this.init(this.$route.params.partner);
      this.canModAmount = true;
      console.log(this.$route.params.partner);
      this.getPartnerFeeInfo(this.$route.params.partner.partnerId)
    }
  },
  methods: {
    // 查询分润比例
    getPartnerFeeInfo(partnerId) {
      let params = {
        partnerId
      }
      getPartnerFee(params).then(res => {
        console.log('商户分润比例', res);
        try {
          this.amount = res.data.findFeePolicyByPartnerId.amount;
        } catch (error) {
          this.amount = null;
        }
      }).catch(error => {
        alert(`${error}`);
      })
    },

    init(item) {
      this.name = item.name;
      this.address = item.address;
      this.phone = item.phone;
      this.description = item.description;
      this.legalRepresentative = item.legalRepresentative;
      this.contact = item.contact;
      this.contactPhone = item.contactPhone;
      this.email = item.email;
      this.taxpayerNumber = item.taxpayerNumber;
      this.bankName = item.bankName;
      this.bankAccount = item.bankAccount;
      this.startTime = item.startTime;
      this.endTime = item.endTime;
      this.feeType = '按比例';
      this.amount = item.amount;
      this.state = item.state;
      this.partnerId = item.partnerId
    },

    // 确认商家合作
    submitPartnerApply() {
      if (this.$route.params.partner) {
        if (this.state === 1) {
          this.modPartnerFunc()
        } else {
          this.$dialog.alert({
            message: '当前商户尚未审核通过，不能修改信息!'
          }).then(res => {
            this.$router.go(-1);
          })
        }
      } else {
        this.addPartnerFunc()
      }
    },

    addPartnerFunc() {
      let openId = sessionStorage.getItem('openid')
      let params = {
        name: this.name,
        address: this.address,
        phone: this.phone,
        description: this.description,
        legalRepresentative: this.legalRepresentative,
        contact: this.contact,
        contactPhone: this.contactPhone,
        email: this.email,
        taxpayerNumber: this.taxpayerNumber,
        bankName: this.bankName,
        bankAccount: this.bankAccount,
        // startTime: this.startTime,
        // endTime: this.endTime,
        feeType: 1,
        amount: Number(this.amount)
      }
      addPartner(openId, params).then(res => {
        console.log('添加商户返回值', res);
        if (res.data.retcode == 0) {
          alert('添加成功');
          this.$router.go(-1);
        } else {
          alert(`${res.data.retmsg}`)
        }
      })
    },

    modPartnerFunc() {
      let openId = sessionStorage.getItem('openid')
      let params = {
        partnerId: this.$route.params.partner.partnerId,
        name: this.name,
        address: this.address,
        phone: this.phone,
        description: this.description,
        legalRepresentative: this.legalRepresentative,
        contact: this.contact,
        contactPhone: this.contactPhone,
        email: this.email,
        taxpayerNumber: this.taxpayerNumber,
        bankName: this.bankName,
        bankAccount: this.bankAccount,
        // startTime: this.startTime,
        // endTime: this.endTime,
        feeType: 1,
        amount: Number(this.amount)
      }
      modPartner(openId, params).then(res => {
        console.log('修改商户返回值', res);
        if (res.data.retcode == 0) {
          alert('修改成功');
          this.$router.go(-1);
        } else {
          alert(`${res.data.retmsg}`)
        }
      })

      if(this.partnerId === 'M202306050008' && this.token){
        console.log('修改车好靓token', this.token);
        modChehaoliangToken(this.token).then(res => {
          console.log('修改车好靓token：', res);
          if(res.data.retcode == 0) {
            alert('修改车好靓token');
          } else {
            alert(`修改车好靓token失败：${res.data.retmsg}`)
          }
        }).catch(error => {
          console.log(`修改车好靓token失败：${JSON.stringify(error)}`);
          alert(`修改车好靓token失败：${JSON.stringify(error)}`)
        })
      }
    }
  }
}
</script>

<style src="../css/add_partner.css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/add_partner.vue